import { safeboxClient, safeboxClientNoToken } from 'myNet'

const ROUTE = '/v1/users'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

interface UpdateUserRequest {
  [key: string]: any
}

interface RolePostRequest {
  [key: string]: any
}

interface InviteInfoRequest {
  token: string
}

interface InviteAcceptRequest {
  token: string
  email: string
}

const UserService = {
  me: async (): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}/me`)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  update: async (userId: string, params: UpdateUserRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.put(`${ROUTE}/${userId}`, params)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  rolePost: async (request: RolePostRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.post(`${ROUTE}/roles`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  inviteInfo: async ({ token }: InviteInfoRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}/invite/info`, { token })
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  inviteAccept: async ({ token, email }: InviteAcceptRequest): Promise<ApiResponse> => {
    const response = await safeboxClientNoToken.post(`${ROUTE}/workspace-invite/${token}/accept`, {
      invitee_email: email,
    })
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  getMyResourceQuota: async (): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}/me/resource-quota`)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  // PR2: 본인 워크스페이스 WRKP 공개키 목록 — Settings ESCROW 전환 시 escrow 생성 대상 ws 조회.
  getMyWrkpPublicKeys: async (): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}/me/wrkp-public-keys`)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  // PR2: 복구정책(NONE/LOCAL/ESCROW) 전환. 에러는 HTTP200+body.code (ZK 규약) → code!==200 시 throw.
  updateRecoveryOption: async (payload: UpdateUserRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.patch(`${ROUTE}/me/recovery-option`, payload)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
}

export default UserService
